export const IS_EMPTY = 'IS_EMPTY';
export const IS_ALIAS = 'IS_ALIAS';
export const IS_VARIANT = 'IS_VARIANT';
export const selectedProductIds = 'selectedProductIds';
export const combineType = 'combineType';
export const combineData = 'combineData';
export const isTypeModalOpen = 'isTypeModalOpen';
export const isCombineAliasModalOpen = 'isCombineAliasModalOpen';
export const isCombineVariantModalOpen = 'isCombineVariantModalOpen';
export const isConfirmActionModalOpen = 'isConfirmActionModalOpen';
